import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

import { Session } from '../services/session';

interface ITeamDrivingRedirectGuardConfig {
  replacePathWith: string;
}
@Injectable()
export class TeamDrivingRedirectGuard {
  constructor(private router: Router, private session: Session) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const urlTree: UrlTree = this.router.parseUrl(state.url);
    const urlSegments: UrlSegment[] = urlTree.root.children.primary.segments || [];
    const routeConfig: ITeamDrivingRedirectGuardConfig = route.data.teamDrivingRedirectGuard;
    const redirectUrlArray: Array<string | Params> = [ urlSegments // Array <string | params>
      .map((urlSegment: UrlSegment) => {
        return urlSegment.path === route.routeConfig.path ? routeConfig.replacePathWith : urlSegment.path;
      })
      .join('/')];

    if (urlSegments.length > 0) {
      const params: Params = urlSegments[urlSegments.length - 1].parameters || {};
      redirectUrlArray.push(params);
    }

    this.router.navigate(redirectUrlArray);
    return false;
  }
}
